
<div fxLayout="column">
  <div class="box">
    <mat-accordion>
      @for (data of list; track data; let i = $index) {
        <mat-expansion-panel class="mat-elevation-z0 potencial-list"
          [ngClass]="{'grey-bg': data.recomendado, 'soft-grey-bg': !data.recomendado}"
          >
          <mat-expansion-panel-header class="panel-height" style="padding-left: 40px; padding-right: 40px;">
            <mat-panel-title fxLayout="row" fxLayoutGap="15px">
              <mat-checkbox color="primary" fxFlex="5" class="txt-center" [checked]="data.checado" [disabled]="!canChange"
              (click)="$event.stopPropagation();" (change)="togglePotential(i, data)"></mat-checkbox>
              <span class="body-title" fxFlex="70"> {{data.eixo}}</span>
              <div fxFlex="5">
                <div class="data-potencial-header">Total</div>
                <span class="number-value"> {{data.total}} </span>
              </div>
              <div fxFlex="15">
                <div class="data-potencial-header">Representatividade</div>
                <span class="number-value"> {{data.representatividade | percent: '1.2-2'}}</span>
              </div>
              <div fxFlex="5" class="soma-potencial-column">
                <div class="data-potencial-header">Soma</div>
                <span class="number-value soma"> {{data.soma | percent: '1.2-2'}}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="column" fxLayoutGap="10px" class="potencial-detail" fxFlex="60">
            <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
              <div class="potencial-detail-header">
                <div class="potencial-detail-header-margin">
                  <div fxFlex="25"></div>
                  <div fxFlex="25" class="header-table-detalhes-potencial">Graduação</div>
                  <div fxFlex="25" class="header-table-detalhes-potencial">Mestrado</div>
                  <div fxFlex="25" class="header-table-detalhes-potencial">Doutorado</div>
                </div>
              </div>
              <div class="potencial-detail-body potencial-detail-body-border">
                <div class="potencial-detail-body-margin" fxLayout="row">
                  <span fxFlex="25" fxLayoutAlign="end" style="font-weight: bold;">Total</span>
                  <span fxFlex="25" class="txt-center">{{data.notaGraduacao !== null ?
                  data.notaGraduacao : '---'}}</span>
                  <span fxFlex="25" class="txt-center">{{data.totalMestrado !== null ? data.totalMestrado
                  : '---'}}</span>
                  <span fxFlex="25" class="txt-center">{{data.totalDoutorado !== null ?
                  data.totalDoutorado : '---'}}</span>
                </div>
              </div>
              <div class="potencial-detail-body">
                <div class="potencial-detail-body-margin" fxLayout="row">
                  <span fxFlex="25" fxLayoutAlign="end" style="font-weight: bold;">Nota</span>
                  <span fxFlex="25" class="txt-center">{{data.notaGraduacao !== null ?
                  data.notaGraduacao : '---'}}</span>
                  <span fxFlex="25" class="txt-center">{{data.notaMestrado !== null ? data.notaMestrado :
                  '---'}}</span>
                  <span fxFlex="25" class="txt-center">{{data.notaDoutorado !== null ? data.notaDoutorado
                  : '---'}}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>

<!--<div fxLayout="column">
<div fxLayout="row" class="body-content-header" fxLayoutGap="15px">
  <div fxFlex="5"></div>
  <div fxFlex="50"></div>
  <div fxFlex="15" class="txt-center">Total</div>
  <div fxFlex="15" class="txt-center">Representatividade</div>
  <div fxFlex="15" class="txt-center soma">Soma</div>
</div>

<div class="box">
  <mat-accordion>
    <mat-expansion-panel hideToggle class="mat-elevation-z0 potencial-list"
      [ngClass]="{'yellow-bg': data.recomendado}"
      *ngFor="let data of list; let i = index">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayout="row" fxLayoutGap="15px">
          <mat-checkbox fxFlex="5" class="txt-center" [checked]="data.checado" [disabled]="!canChange"
          (click)="$event.stopPropagation();" (change)="togglePotential(i, data)"></mat-checkbox>
          <span class="body-title" fxFlex="50"> {{data.eixo}}</span>
          <span class="txt-center" fxFlex="15"> {{data.total}} </span>
          <span class="txt-center" fxFlex="15"> {{data.representatividade | percent: '1.2-2'}}</span>
          <span class="txt-center soma" fxFlex="15"> {{data.soma | percent: '1.2-2'}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column" fxLayoutGap="10px" class="potencial-detail">
        <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">

          <div class="potencial-detail-header">
            <div class="potencial-detail-header-margin">
              <div fxFlex="25"></div>
              <div fxFlex="25" class="txt-center">Graduação</div>
              <div fxFlex="25" class="txt-center">Mestrado</div>
              <div fxFlex="25" class="txt-center">Doutorado</div>
            </div>
          </div>

          <div class="potencial-detail-body potencial-detail-body-border">
            <div class="potencial-detail-body-margin" fxLayout="row">
              <span fxFlex="25" fxLayoutAlign="end">Total</span>
              <span fxFlex="25" class="txt-center">{{data.notaGraduacao !== null ?
              data.notaGraduacao : '---'}}</span>
              <span fxFlex="25" class="txt-center">{{data.totalMestrado !== null ? data.totalMestrado
              : '---'}}</span>
              <span fxFlex="25" class="txt-center">{{data.totalDoutorado !== null ?
              data.totalDoutorado : '---'}}</span>
            </div>
          </div>

          <div class="potencial-detail-body">
            <div class="potencial-detail-body-margin" fxLayout="row">
              <span fxFlex="25" fxLayoutAlign="end">Nota</span>
              <span fxFlex="25" class="txt-center">{{data.notaGraduacao !== null ?
              data.notaGraduacao : '---'}}</span>
              <span fxFlex="25" class="txt-center">{{data.notaMestrado !== null ? data.notaMestrado :
              '---'}}</span>
              <span fxFlex="25" class="txt-center">{{data.notaDoutorado !== null ? data.notaDoutorado
              : '---'}}</span>
            </div>
          </div>
        </div>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</div>
</div>-->